import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { CardGridItem, Container } from "../../../components";
import { Card } from "antd";
import React, { useState } from "react";
import { useStores } from "../../../store";
import { Tutorial } from "../tutorial";
import { useMutate } from "../../../hooks/useMutate";
import { RouteHttpVerb } from "@tatum/utils";
import { showSuccess } from "../../../utils/message";
import { getImageUrl } from "../../../utils/image";
import "./index.scss";
import { Page } from "../../../models";
import { TestnetWarning } from "../testnetWarning";
export var ApiKeyOverview = function ApiKeyOverview() {
  var _apiKeyStore$apiKey;

  var _useStores = useStores(),
      apiKeyStore = _useStores.apiKeyStore,
      pageStore = _useStores.pageStore;

  var _useMutate = useMutate({
    path: "/dismiss-tutorial",
    method: RouteHttpVerb.POST
  }),
      mutate = _useMutate.mutate;

  var _useState = useState(apiKeyStore === null || apiKeyStore === void 0 ? void 0 : (_apiKeyStore$apiKey = apiKeyStore.apiKey) === null || _apiKeyStore$apiKey === void 0 ? void 0 : _apiKeyStore$apiKey.isTutorialDismissed),
      _useState2 = _slicedToArray(_useState, 2),
      isDismissed = _useState2[0],
      setDismissTutorial = _useState2[1];

  var dismissTutorial = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setDismissTutorial(true);
              _context.next = 3;
              return mutate();

            case 3:
              showSuccess("Tutorial hidden.");

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function dismissTutorial() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, !isDismissed && /*#__PURE__*/React.createElement(Tutorial, {
    dismissTutorial: dismissTutorial
  }), apiKeyStore.apiKey.testnet && /*#__PURE__*/React.createElement(TestnetWarning, null), /*#__PURE__*/React.createElement(Container, {
    isGridCard: true
  }, /*#__PURE__*/React.createElement(Card, {
    title: /*#__PURE__*/React.createElement("img", {
      className: "header-overview",
      src: getImageUrl("header-overview.png")
    })
  }, /*#__PURE__*/React.createElement(CardGridItem, {
    title: "Your Tatum plan",
    description: apiKeyStore.apiKey.plan
  }), /*#__PURE__*/React.createElement(CardGridItem, {
    hoverable: true,
    title: "Your Tatum API key",
    description: apiKeyStore.apiKey.apiKey,
    onClick: function onClick() {
      return pageStore.setPage(Page.GET_API_KEY);
    }
  }), /*#__PURE__*/React.createElement(CardGridItem, {
    title: "Network",
    description: "".concat(apiKeyStore.apiKey.testnet ? "Testnet" : "Mainnet")
  }), /*#__PURE__*/React.createElement(CardGridItem, {
    title: "Remaining credits for month",
    description: apiKeyStore.apiKey.remainingCredits.toString()
  }), /*#__PURE__*/React.createElement(CardGridItem, {
    title: "Credits usage last month",
    description: apiKeyStore.apiKey.usedCredits.toString()
  }), /*#__PURE__*/React.createElement(CardGridItem, {
    hoverable: true,
    title: "Total NFTs created",
    description: apiKeyStore.apiKey.nftCreated.toString(),
    onClick: function onClick() {
      return pageStore.setPage(Page.NFTS_LAZY);
    }
  }), /*#__PURE__*/React.createElement(CardGridItem, {
    hoverable: true,
    title: "Total NFTs sold",
    description: apiKeyStore.apiKey.nftSold.toString(),
    onClick: function onClick() {
      return pageStore.setPage(Page.NFTS_MINTED);
    }
  }))));
};